(function () {
  'use strict';

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehavior() {
    return motionQuery.matches ? 'auto' : 'smooth';
  }

  function labelFor(field) {
    if (!field.labels || !field.labels.length) return field.name;
    const clone = field.labels[0].cloneNode(true);
    Array.from(clone.querySelectorAll('.contact-flow__label-note')).forEach(function (note) {
      note.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function setupFlow(root) {
    const form = root.querySelector('[data-contact-form]');
    if (!form) return;

    const steps = Array.from(form.querySelectorAll('[data-contact-step]'));
    const topics = Array.from(form.querySelectorAll('[data-contact-topic]'));
    if (!steps.length || !topics.length) return;

    const branches = Array.from(form.querySelectorAll('[data-contact-branch]'));
    const fields = Array.from(form.querySelectorAll('[data-contact-field]'));
    const review = form.querySelector('[data-contact-review]');
    const summary = form.querySelector('[data-contact-summary]');
    const topicError = form.querySelector('[data-contact-topic-error]');
    const bodyField = form.querySelector('[data-contact-body]');
    const baseDescriptions = new Map();
    const lastStep = steps.length;
    let current = 1;

    fields.forEach(function (field) {
      baseDescriptions.set(field, field.getAttribute('aria-describedby') || '');
    });

    function stepAt(index) {
      return (
        steps.find(function (step) {
          return Number(step.getAttribute('data-contact-step')) === index;
        }) || null
      );
    }

    function stepIndexOf(element) {
      const step = element.closest('[data-contact-step]');
      return step ? Number(step.getAttribute('data-contact-step')) : 1;
    }

    function selectedTopic() {
      return (
        topics.find(function (topic) {
          return topic.checked;
        }) || null
      );
    }

    function syncFields() {
      fields.forEach(function (field) {
        const branch = field.closest('[data-contact-branch]');
        const step = field.closest('[data-contact-step]');
        const dormant = branch !== null && branch.hidden;
        field.disabled = dormant;
        if (dormant || (step !== null && step.hidden)) {
          field.removeAttribute('required');
        } else if (field.hasAttribute('data-contact-required')) {
          field.setAttribute('required', '');
        }
      });
    }

    function errorNodeFor(field) {
      const wrapper = field.closest('.contact-flow__field');
      return wrapper ? wrapper.querySelector('[data-contact-error]') : null;
    }

    function clearError(field) {
      field.removeAttribute('aria-invalid');
      const base = baseDescriptions.get(field) || '';
      if (base) field.setAttribute('aria-describedby', base);
      else field.removeAttribute('aria-describedby');
      const node = errorNodeFor(field);
      if (node) node.textContent = '';
    }

    function showError(field, message) {
      field.setAttribute('aria-invalid', 'true');
      const node = errorNodeFor(field);
      if (!node) return;
      node.textContent = message;
      const base = baseDescriptions.get(field) || '';
      field.setAttribute('aria-describedby', (base + ' ' + node.id).trim());
    }

    function validateTopic() {
      if (selectedTopic()) {
        if (topicError) topicError.textContent = '';
        return true;
      }
      if (topicError) topicError.textContent = 'Pick a topic so this reaches the right person.';
      return false;
    }

    function problemsInStep(index) {
      const step = stepAt(index);
      if (!step) return [];
      if (index === 1) return validateTopic() ? [] : [topics[0]];
      const problems = [];
      Array.from(step.querySelectorAll('[data-contact-field]')).forEach(function (field) {
        if (field.disabled) return;
        clearError(field);
        if (field.checkValidity()) return;
        showError(field, field.validationMessage);
        problems.push(field);
      });
      return problems;
    }

    function announceProblems(problems) {
      if (summary) {
        summary.textContent = problems.length ? 'Check the highlighted fields and try again.' : '';
      }
      const first = problems[0];
      if (!first || first.disabled) return;
      first.focus({ preventScroll: true });
      first.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
    }

    function reviewRows() {
      const rows = [];
      const topic = selectedTopic();
      if (topic) rows.push(['Topic', topic.value]);
      fields.forEach(function (field) {
        if (field.disabled) return;
        const value = field.value.trim();
        if (!value) return;
        rows.push([labelFor(field), value]);
      });
      return rows;
    }

    function buildReview() {
      const rows = reviewRows();
      if (bodyField) {
        bodyField.value = rows
          .map(function (row) {
            return row[0] + ': ' + row[1];
          })
          .join('\n');
      }
      if (!review) return;
      review.textContent = '';
      rows.forEach(function (row) {
        const wrapper = document.createElement('div');
        wrapper.className = 'contact-flow__review-row';
        const term = document.createElement('dt');
        term.className = 'contact-flow__review-term';
        term.textContent = row[0];
        const value = document.createElement('dd');
        value.className = 'contact-flow__review-value';
        value.textContent = row[1];
        wrapper.appendChild(term);
        wrapper.appendChild(value);
        review.appendChild(wrapper);
      });
    }

    function applyTopic() {
      const topic = selectedTopic();
      const slug = topic ? topic.getAttribute('data-contact-topic') : null;
      branches.forEach(function (branch) {
        branch.hidden = branch.getAttribute('data-contact-branch') !== slug;
      });
      syncFields();
    }

    function goTo(index, moveFocus) {
      current = Math.min(Math.max(index, 1), lastStep);
      steps.forEach(function (step) {
        step.hidden = Number(step.getAttribute('data-contact-step')) !== current;
      });
      syncFields();
      if (summary) summary.textContent = '';
      if (current === lastStep) buildReview();
      const step = stepAt(current);
      if (!step || moveFocus === false) return;
      const focusTarget = step.querySelector('[data-contact-focus]') || step;
      focusTarget.focus({ preventScroll: true });
      step.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    }

    topics.forEach(function (topic) {
      topic.addEventListener('change', function () {
        if (!topic.checked) return;
        applyTopic();
        if (!validateTopic()) return;
        if (current === 1) goTo(2, true);
      });
    });

    Array.from(form.querySelectorAll('[data-contact-next]')).forEach(function (button) {
      button.addEventListener('click', function () {
        const problems = problemsInStep(current);
        if (problems.length) {
          announceProblems(problems);
          return;
        }
        goTo(current + 1, true);
      });
    });

    Array.from(form.querySelectorAll('[data-contact-back]')).forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(current - 1, true);
      });
    });

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true' && field.checkValidity()) clearError(field);
      });

      field.addEventListener('blur', function () {
        if (field.disabled || field.value.trim() === '') return;
        if (field.checkValidity()) clearError(field);
        else showError(field, field.validationMessage);
      });
    });

    form.addEventListener('submit', function (event) {
      fields.forEach(function (field) {
        if (!field.disabled && field.hasAttribute('data-contact-required')) {
          field.setAttribute('required', '');
        }
      });

      let problems = [];
      for (let index = 1; index <= lastStep; index += 1) {
        problems = problems.concat(problemsInStep(index));
      }

      if (!problems.length) {
        buildReview();
        return;
      }

      event.preventDefault();
      goTo(stepIndexOf(problems[0]), false);
      announceProblems(problems);
    });

    form.noValidate = true;
    applyTopic();
    goTo(1, false);
    root.setAttribute('data-contact-ready', 'true');
  }

  Array.from(document.querySelectorAll('[data-contact-flow]')).forEach(setupFlow);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-contact-flow]');
    if (root) setupFlow(root);
  });
})();
